module.exports = __webpack_public_path__ + "img/2_list1.ba9e89c7.png";